import React, {useState} from "react";
import {GrStatusGood} from "react-icons/gr";
import moment from "moment/moment";
import StaffNZCARShowPayload from "./StaffNZCARShowPayload";

export default function StaffNZCARShowInfoRow({row,view}) {

    const [openPayload, setOpenPayload] = useState(false);
    if (view === 'new') return (
        <>
            <a href={""} onClick={(e) => {
                e.preventDefault();
                setOpenPayload(true)
            }}>
                NZCAR data for this animal
            </a>
            {
                (openPayload === true) ?
                    <StaffNZCARShowPayload {...{row,view}} key={Date.now()} isOpen={openPayload} setIsOpen={setOpenPayload}
                                           message={row.payload}/>
                    : undefined
            }
        </>
    )

    if (view === 'success') return (
        <>
            <GrStatusGood siz={24}/>
        </>
    )

    // errors
    return (
        <>
            <a href={""} className={"btn"} onClick={(e) => {
                e.preventDefault();
                setOpenPayload(true)
            }}>
                Error message
            </a><br/>
            <small style={{whiteSpace: 'nowrap'}}>{moment(row.created_at).format("DD/MM/YYYY HH:mm")}</small>
            {
                (openPayload === true) ?
                    <StaffNZCARShowPayload {...{row,view}} key={Date.now()} isOpen={openPayload} setIsOpen={setOpenPayload}
                                           message={JSON.parse(row.message)}/>
                    : undefined
            }
        </>
    )

}
